import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Callout } from '@bingads-webui-react/callout';
// import { Callout } from '@fluentui/react';
import { DefaultButton, PrimaryButton } from '@bingads-webui-react/fabric-with-signal';
import { withLock, keyVault, priorityLevel } from '@bingads-webui-react/popup-manager';
import { LearnMoreLink, HelpIcon } from '@bingads-webui-campaign-react/help';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { curlyTemplate } from '@bingads-webui-universal/primitive-utilities';

import { getStyles } from './styles';

const CalloutCardInternal = ({
  i18n,
  title,
  content,
  contentHelpId,
  buttons,
  target,
  classes,
  coupon,
  couponHelpId,
  currency,
  logger,
}) => {
  const contentNode = useMemo(() => (
    <div>
      <div className="import-callout-card-content">
        {
        coupon ?
          <div className="import-callout-card-coupon">
            <span>
              {curlyTemplate(i18n.getString(_TL_('Receive {{couponValue}} Credit')))({ couponValue: i18n.formatCurrency(coupon.CouponValue, currency) })}
              {
              couponHelpId ?
                <HelpIcon
                  topic={couponHelpId}
                /> : <></>
              }
            </span>
          </div> : <></>
        }
        <span>{content}</span>
        {contentHelpId
         ? <LearnMoreLink topic={contentHelpId} linkText={i18n.getString(_TL_('Learn more'))} />
         : null}
      </div>
      <div className="import-callout-card-buttons">
        {
          buttons.map(({ isPrimary, label, onClick }) => (
            isPrimary
              ? <PrimaryButton
                  key={`Primary-${label}`}
                  text={label}
                  onClick={() => {
                    logger.logTrace('[CalloutCardInternal] Clicked on done button');
                    onClick();
                  }}
              />
              : <DefaultButton
                  key={`Default-${label}`}
                  text={label}
                  onClick={() => {
                    logger.logTrace('[CalloutCardInternal] Clicked on dismiss button');
                    onClick();
                  }}
              />
          ))
        }
      </div>
    </div>
  ), [buttons, content, contentHelpId, coupon, couponHelpId, currency, i18n]);

  useEffect(() => {
    logger.logTrace('[CalloutCardInternal] Imperssion');
  }, []);

  return (
    <Callout
      title={title}
      content={contentNode}
      popoverClassName={classes.importCalloutCardPopup}
      popoverId="import-callout-card-popover-id"
      target={target}
      placement="bottom"
      show
      rootClose={false}
      closeButton={false}
    />
  );
};

CalloutCardInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  contentHelpId: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    isPrimary: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  })).isRequired,
  target: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({}).isRequired,
  coupon: PropTypes.shape({}),
  couponHelpId: PropTypes.string,
  currency: PropTypes.string.isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }),
};

CalloutCardInternal.defaultProps = {
  contentHelpId: null,
  couponHelpId: null,
  coupon: null,
  logger: {
    logTrace: () => {},
  },
};

export const CalloutCardComponent = withDefaultStyles(CalloutCardInternal, getStyles);

export const CalloutCardWithLock = withLock(CalloutCardComponent, {
  lockKey: keyVault.teachingBubble,
  priority: priorityLevel.teachingBubble,
  autoClose: false,
});

export const CalloutCardWithAutoClose = withLock(CalloutCardComponent, {
  lockKey: keyVault.teachingBubble,
  priority: priorityLevel.teachingBubble,
  autoClose: true,
});
